<template>
  <div>
    <div v-if="auth !== null && auth.user !== null">
      <button class="btn btn-primary" v-on:click.prevent="logoutUser" name="button">Logout</button>
    </div>
    <div v-else>
      <p class="error-message" v-if="error_message !== null">{{ error_message }}</p>
      <form class="" method="post" v-on:submit.prevent="loginUser">
        <label for="email">email</label>
        <input type="text" v-model="user.email" name="email">
        <label for="password">password</label>
        <input type="password" v-model="user.password" name="password">
        <button class="btn btn-primary" type="submit" name="button">login</button>
      </form>
    </div>
  </div>
</template>

<script>
import authService from '../auth'

export default {
  data () {
    return {
      'auth': authService,
      'user': {
        'email': '',
        'password': ''
      },
      'error_message': null
    }
  },
  methods: {
    loginUser: function (e) {
      this.auth.login(this.user.email, this.user.password)
        .then(res => {
          this.error_message = null
          this.$router.push('/')
        })
        .catch(error => {
          this.error_message = error.message
        })
    },
    logoutUser: function (e) {
      console.log('logging out')
      this.auth.logout()
      this.user.email = ''
      this.user.password = ''
    }
  }
}

</script>

<style scoped>
  .error-message {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?4ef52304